import { FeatureAppConfig } from '..';
import { ImageModel } from '../typings/images-model-map';
import {
  FeatureAppContent,
  useFeatureAppContent,
} from './use-feature-app-content';
import { useFeatureAppEnvironment } from './use-feature-app-environment';

const mergeAppConfigs = (
  config: FeatureAppConfig,
  content: FeatureAppContent,
): FeatureAppConfig => {
  let finalConfig = { ...config };
  if (!content) return finalConfig;
  if (content.fiveStarsConfig?.length) {
    finalConfig = {
      ...finalConfig,
      fiveStarsConfig: content.fiveStarsConfig[0],
    };
  }
  if (content.imageModelMap?.length) {
    finalConfig = {
      ...finalConfig,
      imageModel: content.imageModelMap[0] as ImageModel,
    };
  }
  if (content.modelConfiguration?.length) {
    finalConfig = {
      ...finalConfig,
      modelConfiguration: content.modelConfiguration[0],
    };
  }
  return finalConfig;
};
const FA_SERVICES_NAME = 'fa-services';

export function useFeatureAppConfig(): FeatureAppConfig {
  let { config, featureServices } = useFeatureAppEnvironment();
  const content = useFeatureAppContent();
  const serviceConfig = featureServices['service-config-provider'];
  if (config && !config.faServicesUrl) {
    if (
      serviceConfig &&
      serviceConfig?.configs[FA_SERVICES_NAME] &&
      serviceConfig.configs[FA_SERVICES_NAME]?.urlOrigin
    ) {
      config = {
        ...config,
        faServicesUrl: serviceConfig.configs[FA_SERVICES_NAME]?.urlOrigin,
      };
    } else {
      throw new Error(
        "FeatureAppConfig Service Config: No 'fa-service' is configured",
      );
    }
  }
  return config ? mergeAppConfigs(config, content) : { faServicesUrl: '' };
}
